import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import vision from "../../../assets/images/feature/vision1.png";
import shape from "../../../assets/images/feature/shape.png";
import { Link } from "react-router-dom";

const VisionSection = () => {
  const [cmsData, setCmsData] = useState([]);
  const [status, setStatus] = useState(null);
  const [imagePath, setimagePath] = useState([]);
  const [fooder, setfooder] = useState("");

  useEffect(() => {
    fetchCMSData();
    footerdata()
  }, []);

  const fetchCMSData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/cmslist`);
      setCmsData(res.data.data); // Save entire list
      setStatus(res.data.status);
      setimagePath(res.data.imagePath);
    } catch (error) {
      console.error("Error fetching CMS data", error);
    }
  };
    const footerdata = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/site-setting`
      );
      setfooder(res.data.data);
      // setstatus(res.data.status);
    } catch (error) {}
  };
  // Filter items by type
  const aboutUsItems = cmsData.filter((item) => item.type === "vision");
  return (
    <>
     {fooder.visionpermission == 1 ? (
        <section className="vision-section py-60  bg-white">
          <Container>
            {aboutUsItems.map((item, index) => (
              <Row className="align-items-center">
                <Col lg={6} className="mb-4 mb-lg-0 order_Second p-3">
                  <div className="position-relative">
                    <img
                      src={item?.image ? `${imagePath}${item.image}` : vision}
                      alt="Main"
                      className="vision_img img-fluid rounded"
                    />
                    <img src={shape} alt="vision" className="vision_shape" />
                  </div>
                </Col>

                <Col lg={6} className=" pl-60 pl-md-15 pl-xs-15">
                  <div className="vision_right sec-title">
                    <h6 className="color-primary mb-8">–––– Vision</h6>
                    <h2 className="title mb-4">{item.name}</h2>
                    <p
                      className="mb-4"
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    ></p>
                    {/* <Link to="/About-us" className="educate-btn">
                      <span className="educate-btn__curve"></span> Get Started
                    </Link> */}
                  </div>
                </Col>
              </Row>
            ))}
          </Container>
        </section>
      ) : (
        ""
      )}
    </>
  );
};

export default VisionSection;
